"use strict";

require("core-js/modules/es.object.from-entries.js");

exports.__esModule = true;
exports.useQuery = exports.toCapitalize = exports.startsWith = exports.removeSpecialChar = exports.numberFormat = exports.isNotEmpty = exports.isIncludeSplChar = exports.goBack = exports.getUrlParams = exports.getPropertyLink = exports.getPidFromUrl = exports.filterNumber = exports.endsWith = exports.doRedirect = exports.currencyFormat = exports.ScrollToTop = exports.AppendScript = void 0;

var _lodash = require("lodash");

var _scrollIntoViewIfNeeded = _interopRequireDefault(require("scroll-into-view-if-needed"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var AppendScript = function AppendScript(url, id, callback) {
  if (document.getElementById(id) === null) {
    var e = document.createElement("script");
    e.src = url;
    e.id = id;
    e.async = true;
    e.defer = true;
    e.type = "text/javascript";
    e.addEventListener("load", callback);
    document.getElementsByTagName("body")[0].appendChild(e);
  }
};

exports.AppendScript = AppendScript;

var startsWith = function startsWith(str, word) {
  return (str == null ? void 0 : str.lastIndexOf(word, 0)) === 0;
};

exports.startsWith = startsWith;

var endsWith = function endsWith(str, word) {
  return (str == null ? void 0 : str.slice(-1)) === word;
};

exports.endsWith = endsWith;

var ScrollToTop = function ScrollToTop(ref, top) {
  if (top === void 0) {
    top = 100;
  }

  (0, _scrollIntoViewIfNeeded["default"])(ref, {
    behavior: function behavior(actions) {
      return actions.forEach(function (_ref) {
        var el = _ref.el;
        el.scrollTop = top;
      });
    }
  });
};

exports.ScrollToTop = ScrollToTop;

var currencyFormat = function currencyFormat(num, currency, withSpace) {
  if (currency === void 0) {
    currency = "\xA3";
  }

  if (withSpace === void 0) {
    withSpace = true;
  }

  var filterNum = filterNumber(num);

  if (!filterNum) {
    return currency + " 0";
  }

  if (withSpace) {
    return currency + " " + new Intl.NumberFormat("en-US", {}).format(filterNum);
  } else {
    return "" + currency + new Intl.NumberFormat("en-US", {}).format(filterNum);
  }
};

exports.currencyFormat = currencyFormat;

var filterNumber = function filterNumber(str) {
  if (!str) return 0;
  str = str.toString();
  return parseInt(str.replace(/[^\d.]/g, ""), 10);
};

exports.filterNumber = filterNumber;

var numberFormat = function numberFormat(num) {
  if (!num) return 0;
  return new Intl.NumberFormat("en-US", {}).format(num);
};

exports.numberFormat = numberFormat;

var getUrlParams = function getUrlParams() {
  var urlSearchParams = new URLSearchParams(window.location.search);
  return Object.fromEntries(urlSearchParams.entries());
};

exports.getUrlParams = getUrlParams;

var isIncludeSplChar = function isIncludeSplChar(text) {
  var format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/;
  return format.test(text);
};

exports.isIncludeSplChar = isIncludeSplChar;

var toCapitalize = function toCapitalize(str) {
  if (!(0, _lodash.isEmpty)(str)) {
    return (0, _lodash.startCase)((0, _lodash.toLower)(str.replace(/[^a-zA-Z ]/g, " ").replace(/\s+/g, " ")));
  }

  return str;
};

exports.toCapitalize = toCapitalize;

var removeSpecialChar = function removeSpecialChar(val, symbol) {
  if (symbol === void 0) {
    symbol = "-";
  }

  if (!(0, _lodash.isEmpty)(val)) {
    return val.replace(/[^\w\s]/gi, " ").replace(/\s\s+/g, " ").replace(/ /gi, symbol).toLowerCase();
  }

  return val;
};

exports.removeSpecialChar = removeSpecialChar;

var isNotEmpty = function isNotEmpty(val) {
  if (typeof val != "undefined" && val !== null && val !== "") {
    return true;
  }

  return false;
};

exports.isNotEmpty = isNotEmpty;

var doRedirect = function doRedirect(url) {
  if (typeof window !== "undefined") {
    window.location.href = url;
  }
};

exports.doRedirect = doRedirect;

var useQuery = function useQuery(location, key) {
  var query = new URLSearchParams(location.search);
  return query.get(key);
};

exports.useQuery = useQuery;

var goBack = function goBack() {
  navigate(-1);
};

exports.goBack = goBack;

var getPidFromUrl = function getPidFromUrl(url) {
  if (url === void 0) {
    url = "";
  }

  if (!url) {
    url = typeof window !== "undefined" ? window.location.href : "";
  }

  var urlObj = url.split("?")[0].split("-");
  return urlObj[urlObj.length - 1].replace("/", "").replace("/#", "").split("?")[0];
};

exports.getPidFromUrl = getPidFromUrl;

var getPropertyLink = function getPropertyLink(uriStr, hit) {
  return "/" + uriStr + hit.slug + "-" + hit.objectID + "/";
};

exports.getPropertyLink = getPropertyLink;